export var NAVIGATION_GROUP_MAX_SIZE_DEFAULT = 8;
export var ELLIPSIS_INDEX = 5;